import { propertyType } from '../type'
import type { type as propertyTypeEnum, structure } from '../type/property_type'
import { structureZ, typeZ } from '../type/property_type'

/**
 * 文字列を structure 型に変換
 */
export const toStructure = (value: string): structure => {
  return structureZ.parse(value)
}

/**
 * 文字列を type 型に変換
 */
export const toType = (value: string): propertyTypeEnum => {
  return typeZ.parse(value)
}

/**
 * structure の表示ラベルを取得
 */
export const structureLabel = (value: structure | null | undefined): string => {
  if (!value) return '-'
  return (
    propertyType.PROPERTY_STRUCTURES.find((s) => s.key === value)?.value ?? '-'
  )
}

/**
 * type の表示ラベルを取得
 */
export const typeLabel = (
  value: propertyTypeEnum | null | undefined,
): string => {
  if (!value) return '-'
  return propertyType.PROPERTY_TYPES.find((t) => t.key === value)?.value ?? '-'
}
